module.exports = __webpack_public_path__ + "static/media/order_icon22.1380e4bb.png";